import React from 'react'
import {connect} from 'react-redux'
import NavBarItem from "../components/NavBarItem"
import {tooltips} from "../constants"
import jsonpack from 'jsonpack'



class SaveDocument extends React.Component {
    constructor(props) {
        super(props)
        this.state = { 
            saving : false
        }
    }
    
    render() {
        if(this.state.saving){
            return (
                <NavBarItem onClick={()=>this.saveDoc(this.props.fileContents, this.props.fileName, this.props.globalSettings, this.props.presetSettings)} name="Save Document" tooltip={tooltips.SaveDocument} color={"#4CAF50"} icon={this.props.icon} />
            )
        } else{
    
            return (
                <NavBarItem onClick={()=>this.saveDoc(this.props.fileContents, this.props.fileName, this.props.globalSettings, this.props.presetSettings)} name="Save Document" tooltip={tooltips.SaveDocument} icon={this.props.icon} />
            )
        }
        return 
    }

    saveDoc = (fileContents, fileName, globalSettings, presetSettings) => {
    console.log(presetSettings)
    var docDump = {"actions": fileContents.toJS(), "settings" : globalSettings.toJS(), "presetSettings" : presetSettings.present.toJS() }
    var textToWrite = jsonpack.pack(docDump);
    var textFileAsBlob = new Blob([textToWrite], {type:'application/json'});
    if(fileName == ""){
        fileName = "untitled";
    }
    if( this.fileNameToSaveAs == fileName + ".dlcfg" && this.fileHandle){
        var that = this
        console.log("save operation", this.fileHandle)
        writeData(this.fileHandle, textFileAsBlob).then(function(){
            console.log("saving true")
        })
        this.setState({
            saving:true
                    })
        setTimeout(function(){this.setState({
            saving:false
                    })}.bind(this),1000)
        
        
    } else{
        this.fileNameToSaveAs = fileName + ".dlcfg"
        var that = this
        getNewFileHandle(this.fileNameToSaveAs, textFileAsBlob).then(function(result){
            console.log(result)
            writeData(result, textFileAsBlob)
            that.fileHandle = result
            return result
        }).catch(function(){
            console.log("no file handler")
            that.fileHandle = false
            return false
        });
        

        
    }
    return true;
};
}
async function getNewFileHandle(fileNameToSaveAs) {
    const options = {
      suggestedName:  fileNameToSaveAs,
      types: [
        {
          description: 'Datalooper Config File',
          accept: {
            'application/json': ['.dlcfg'],
          },
        },
      ],
    };
    const handle = await window.showSaveFilePicker(options);
    
    return handle;
  }
async function writeData(handle, blob){
    var file = await handle . getFile()
    var stream = await handle . createWritable()
    await stream.write(blob)
    await stream.close()
}
  
// function destroyClickedElement(event)
// {
//     document.body.removeChild(event.target);
// }

function mapStateToProps(state){
    return{
        fileContents : state.buttonActions.present,
        globalSettings : state.settings,
        presetSettings : state.presetSettings,
        fileName : state.document
    }
}


export default connect(mapStateToProps)(SaveDocument)